<template>
  <section class="new_css">
    <el-row class="new_header">
      <el-col v-if="buttonList.length > 0" :span="24" class="organizetoolbar" style="padding-bottom: 0px">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="select_form">
          <el-form-item label="证书名称:">
            <el-input v-model="selectForm.CertificateName" placeholder="证书名称"></el-input>
          </el-form-item>
          <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        </el-form>
      </el-col>
    </el-row>
    <div class="calc-height">
      <el-table :data="users" highlight-current-row height="100%" @current-change="selectCurrentRow" @row-dblclick="handleShow" class="new_table">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="证书系列" prop="CertificateSeriesName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="证书类别" prop="CertificateTypeName"></el-table-column>
        <el-table-column label="证书名称" prop="CertificateName"></el-table-column>
        <el-table-column label="证书等级" prop="CertificateLevelName"></el-table-column>
        <el-table-column label="补贴金额" prop="CertificateSubsidyAmount"></el-table-column>
        <el-table-column label="费用承担主体" prop="CostBearer">
          <template slot-scope="scope">
            <span v-if="scope.row.CostBearer === 1">社保承担公司</span>
            <span v-else-if="scope.row.CostBearer === 0">所属公司承担</span>
            <span v-else-if="scope.row.CostBearer === 2">集团承担</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="Remarks"></el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <el-pagination align="center" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper,total"
 :page-count="total" :total="totaldata">
    </el-pagination>

    <el-dialog :title="operation ? '新增' : '编辑'" :visible.sync="SakaryVisible" v-model="SakaryVisible" :close-on-click-modal="false">
        <el-form :rules="SakaryRules" ref="SakaryForm" :model="SakaryForm" label-width="100px">
            <el-row>
                <el-col :span="12" style="display:none;">
                    <el-form-item label="Id:" prop="Id">
                        <el-input type="text" v-model="SakaryForm.Id"> </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证书名称:" prop="CertificateName">
                        <el-input type="text" v-model="SakaryForm.CertificateName"> </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证书系列:" prop="CertificateSeriesName">
                        <el-select v-model="SakaryForm.CertificateSeriesName" filterable placeholder="证书系列" @change="CertTypeModel($event)" style="width: 100%">
                            <el-option v-for="item in CertTypeLists" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证书类别:" prop="CertificateTypeName">
                        <el-select v-model="SakaryForm.CertificateTypeName" filterable placeholder="证书类别" @change="CertCategoryModel($event)" style="width: 100%">
                            <el-option v-for="item in CertCategoryLists" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证书等级:">
                        <el-select v-model="SakaryForm.CertificateLevelName" filterable placeholder="证书等级" @change="CertProfessionModel($event)" style="width: 100%">
                            <el-option label="" :value=null></el-option>
                            <el-option v-for="item in CertProfessionLists" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="费用承担主体:" prop="CostBearer">
                        <el-select v-model="SakaryForm.CostBearer" placeholder="费用承担主体" style="width: 100%">
                            <el-option label="" :value=null></el-option>
                            <el-option label="所属公司承担" :value="0"></el-option>
                            <el-option label="社保承担公司" :value="1"></el-option>
                            <el-option label="集团承担" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="补贴金额:" prop="CertificateSubsidyAmount">
                        <el-input type="money" v-model="SakaryForm.CertificateSubsidyAmount">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <label for="Summarize" class="el-form-item__label">备注:</label>
                    <el-input type="textarea" v-model="SakaryForm.Remarks" style="width: 90%"></el-input>
                </el-col>
            </el-row>
            <el-row v-if="operation1">
                <el-col :span="24" style="text-align: center">
                    <el-button type="primary" v-on:click="onSubmit('SakaryForm')">提交</el-button>
                </el-col>
            </el-row>
        </el-form>
    </el-dialog>
  </section>
</template>
<script>
import util from "../../../util/date";
import * as validate from "../../../util/validate";
import UploadFiles from "../../components/UploadFiles";
import {
  GetCertificateByType,
  AddCertificateInfo,
  UpdateInfoCertificateInfo,
  GetCertificateInfo,
  GetCertificateInfoList,
} from "../../api/hr";
import { getButtonList } from "../../promissionRouter";
import UserChoose from "../../components/UserChoose";
import Toolbar from "../../components/newToolbar";
export default {
  components: { Toolbar, UserChoose, UploadFiles },
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页码
      total: null, // 总条数
      totaldata: null,
      operation: false, // true:新增, false:编辑
      operation1: true,
      pageSize: 20, // 每页的数据条数
      page: 1,
      key: 0,
      keyCommitment:0,
      CertTypeLists: [],
      CertCategoryLists: [],
      CertProfessionLists: [],
      SavePlaceLists: [],
      SakaryVisible: false,
      selectForm: {
        CertificateName: null,
      },
      SakaryForm: {
        id: "",
        CertificateSeriesId: "",
        CertificateSeriesName: "",
        CertificateTypeId: "",
        CertificateTypeName: "",
        CertificateLevelId: "",
        CertificateLevelName: null,
        CertificateName: "",
        CertificateSubsidyAmount: 0,
        CostBearer: null,
        Remarks: "",
      },
      users: [],
      buttonList: [],
      SakaryRules: {
        CertificateName:[
          { required: true, message: "请填写证书名称", trigger:"blur"},
        ],
        CertificateSeries: [
          { required: true, message: "请选择证书系列", trigger: "blur" },
        ],
        CertificateType: [
          { required: true, message: "请选择证书类别", trigger: "blur" },
        ],
        // CostBearer: [
        //   { required: true, message: "请选择费用承担主体", trigger: "blur" },
        // ],
        CertificateSubsidyAmount: [
          { required: true, message: "请填写证书补贴金额", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      GetCertificateByType({ type: "证书系列" }).then((res) => {
        this.CertTypeLists = res.data.response;
      });
      GetCertificateByType({ type: "证书类别" }).then((res) => {
        this.CertCategoryLists = res.data.response;
      });
      GetCertificateByType({ type: "证书等级" }).then((res) => {
        this.CertProfessionLists = res.data.response;
      });
      GetCertificateInfo({ id: row.Id }).then((res) => {
        console.log(res.data.response)
        this.SakaryForm = res.data.response;
        this.key += 1;
        this.keyCommitment += 1;
        this.SakaryVisible = true;
      });

      this.operation = false;
      this.operation1 = true;
    },
    handleShow() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      GetCertificateByType({ type: "证书系列" }).then((res) => {
        this.CertTypeLists = res.data.response;
      });
      GetCertificateByType({ type: "证书类别" }).then((res) => {
        this.CertCategoryLists = res.data.response;
      });
      GetCertificateByType({ type: "证书等级" }).then((res) => {
        this.CertProfessionLists = res.data.response;
      });
      GetCertificateInfo({ id: row.Id }).then((res) => {
        this.SakaryForm = res.data.response;
          this.key += 1;
          this.keyCommitment += 1;
        this.SakaryVisible = true;
      });

      this.operation = false;
      this.operation1 = false;
    },
    handleAdd() {
      (this.SakaryForm = {
        id: "",
        CertificateSeriesId: "",
        CertificateSeriesName: "",
        CertificateTypeId: "",
        CertificateTypeName: "",
        CertificateLevelId: "",
        CertificateLevelName: null,
        CertificateName: "",
        CertificateSubsidyAmount: 0,
        CostBearer: null,
        Remarks: "",
      }),
      GetCertificateByType({ type: "证书系列" }).then((res) => {
          console.log(res);
          this.CertTypeLists = res.data.response;
        });
      GetCertificateByType({ type: "证书类别" }).then((res) => {
        this.CertCategoryLists = res.data.response;
      });
      GetCertificateByType({ type: "证书等级" }).then((res) => {
        this.CertProfessionLists = res.data.response;
      });
        this.key += 1;
        this.keyCommitment += 1;
      (this.operation = true), (this.SakaryVisible = true);
      this.operation1 = true;
    },
    // chooseUser() {
    //   this.addUserVisible = true;
    // },
    //获取用户列表
    getData(isCurrent = true) {
      if (isCurrent) {
        this.page = 1;
      }

      let para = {
        page: this.page,
        size: this.pageSize,
        CertificateName: this.selectForm.CertificateName,
      };
      GetCertificateInfoList(para).then((res) => {
        this.total = res.data.response.pageCount;
        this.totaldata = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.loading = false;
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach((element) => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.page = val;
      this.getData(false);
    },
    CertTypeModel(id) {
      let obj = {};
      obj = this.CertTypeLists.find((item) => {
        //model就是上面的数据源
        return item.Name === id; //筛选出匹配数据
      });
      this.SakaryForm.CertificateSeriesId = obj.Id;
    },
    CertCategoryModel(id) {
      let obj = {};
      obj = this.CertCategoryLists.find((item) => {
        //model就是上面的数据源
        return item.Name === id; //筛选出匹配数据
      });
      this.SakaryForm.CertificateTypeId = obj.Id;
    },
    CertProfessionModel(id) {
      let obj = {};
      obj = this.CertProfessionLists.find((item) => {
        //model就是上面的数据源
        return item.Name === id; //筛选出匹配数据
      });
      this.SakaryForm.CertificateLevelId = obj.Id;
    },
    SavePlaceModel(id) {
      let obj = {};
      obj = this.SavePlaceLists.find((item) => {
        //model就是上面的数据源
        return item.Name === id; //筛选出匹配数据
      });
      this.SakaryForm.SavePlaceId = obj.Id;
    },
    onSubmit(formName) {
      this.$confirm("确定要提交吗？", "提示", {}).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.SakaryForm.CertificateLevelName==null){
              this.SakaryForm.CertificateLevelId=null;
            }
            let para = Object.assign({}, this.SakaryForm);
            if (this.operation) {
              //新增
              AddCertificateInfo(para).then((res) => {
                if (res.data.success) {
                  this.$message({
                    message: "添加成功",
                    type: "success",
                    duration: 5000,
                  });
                  this.SakaryVisible = false;
                  this.getData();
                } else {
                  this.$message({
                    message: "添加失败",
                    type: "error",
                    duration: 5000,
                  });
                }
              });
            } else {
              //修改
              UpdateInfoCertificateInfo(para).then((res) => {
                if (res.data.success) {
                  this.$message({
                    message: "修改成功",
                    type: "success",
                    duration: 5000,
                  });
                  this.SakaryVisible = false;
                  this.getData(false);
                } else {
                  this.$message({
                    message: "修改失败",
                    type: "error",
                    duration: 5000,
                  });
                }
              });
            }
          } else {
            this.$message({
              message: "请检查必填项",
              type: "error",
              duration: 5000,
            });
            return false;
          }
        });
      });
    },
    dealFiles(data) {
        console.log(data.backData);
        this.SakaryForm.FileArry = data.backData;
    },
    dealFilesCommitment(data) {
        this.SakaryForm.CommitmentFileArry = data.backData;
    },
  },
  mounted() {
    this.getData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let buttons = window.localStorage.buttList
      ? JSON.parse(window.localStorage.buttList)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers, buttons);
  },
};
</script>
<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.calc-height {
  height: calc(100vh - 300px) !important;
}
</style>

